module.exports = __webpack_public_path__ + "img/administrar-rentas.53f575d6.png";